import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FormFieldComponent } from '../../abstract/form-field/form-field.component';

@Component({
  selector: 'app-form-text-input',
  templateUrl: './form-text-input.component.html',
  styleUrls: ['./form-text-input.component.scss']
})
export class FormTextInputComponent extends FormFieldComponent {
  @Input() type: string = 'text';

  @Output() keyupEnter: EventEmitter<void> = new EventEmitter<void>();

  keyupEnterTrigger() {
    this.keyupEnter.emit();
  }
}
